import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { AssetChubbBookingBannerInterface } from '@app/entities/asset-chubb-booking-banner';
import { AssetChubbBookingBanner } from '@asset-chubb-booking-banner';

@Component({
  selector: 'app-chubb-prime-gift',
  templateUrl: './chubb-prime-gift.component.html',
  styleUrls: ['./chubb-prime-gift.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class ChubbPrimeGiftComponent {

  @Input() isInternationalTrip: boolean;

  constructor() { }

  get giftCopy(): string {
    return this.isInternationalTrip ? this.assetChubbBookingBanner?.INTERNATIONAL_COPY_BY_PRIME_GIFT :
      this.assetChubbBookingBanner?.NATIONAL_COPY_BY_PRIME_GIFT;
  }

  private get assetChubbBookingBanner(): AssetChubbBookingBannerInterface {
    return AssetChubbBookingBanner;
  }

}
